import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import DynamicSingleSideTab from "../../components/dynamicSingleSideTab/dynamicSingleSideTab";

const Configurations = () => {
  const [activeTab, setActiveTab] = useState("documents-configuration");
  const navigate = useNavigate();
  const sideNavElements = [
    { id: "documents-configuration", label: "Documents Configuration" },
    { id: "form-configuration", label: "Form Configuration" },
    { id: "pa-form-configuration", label: "PA Form Configuration" },
    { id: "medicine-name-configuration", label: "Medicine Name Configuration" },
    {
      id: "prescription-parsing-configuration",
      label: "Prescription Parsing Configuration",
    },
    { id: "health-facility", label: "Health Facility Configuration" },
    { id: "pharma-pa-configuration", label: "Pharma PA Configuration" },
    { id: "delivery-configuration", label: "Delivery Configuration" },
    { id: "medical-necessity-configuration", label: "Medical Necessity" },
    { id: "credentials-configuration", label: "Credentials Configuration" },
    { id: "provider-list", label: "Provider Configuration" },
    // {
    //   id: "provider-options-configuration",
    //   label: "Provider Options Configuration",
    // },
    { id: "medication-list", label: "Medication List" },
    { id: "biosimilar-config", label: "Drug Family Configuration" },
    { id: "validation-funnel", label: "No Touch Config" },
    { id: "calling-configuration", label: "Calling Configuration" },
    { id: "poc-configuration", label: "POC Configuration" },
    { id: "first-stp-bucketing", label: "First STP Bucketing" },
  ];

  return (
    <>
      <div className="home-container">
        <div className="home-container__content">
          <div className="home-container__content-left">
            {sideNavElements.map((sideNavElement) => (
              <DynamicSingleSideTab
                key={sideNavElement.id}
                id={sideNavElement.id}
                label={sideNavElement.label}
                isActive={activeTab === sideNavElement.id}
                onTabClick={(id: string) => {
                  setActiveTab(id);
                  navigate(id);
                }}
              />
            ))}
          </div>
          <div className="home-container__content-right">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default Configurations;
